const {localizeDate} = require("../utils/date");

exports.validate = function (properties) {
    let returnObject = {
        valid: true,
        errors: []
    };

    for (let key in properties) {
        if (properties.hasOwnProperty(key)) {
            switch (key) {
                case 'valid-from':
                    break;
                case 'valid-to':
                    if (properties.hasOwnProperty('valid-from')) {
                        let fromString = properties['valid-from'];
                        let toString = properties[key];
                        if (fromString !== '' && fromString !== null && toString !== '' && toString !== null) {
                            let from = exports.formatDate(fromString, 'mm/dd/yyyy');
                            let to = exports.formatDate(toString, 'mm/dd/yyyy');
                            if (to < from) {
                                returnObject.valid = false;
                                returnObject.errors.push(Lang.langGet('The \'valid from\' date must lie before the \'valid to\' date.'));
                            }
                        }
                    }
                    break;
            }
        }
    }

    return returnObject;
};

exports.checkValidity = function (from, to, time = null) {
    let returnObject = {
        status: null,
        text: ''
    };
    let now = new Date();

    if (from === '' || from === 'null' || from === null) {
        from = undefined;
    }

    if (to === '' || to === 'null' || to === null) {
        to = undefined;
    }

    if (from === undefined && to === undefined) {
        returnObject.status = 'normal';
        returnObject.text = Lang.langGet('always valid');
    } else if (from === undefined && to !== undefined) {
        let toParsed = exports.formatDate(to, 'MM/dd/YYYY');
        toParsed.setDate(toParsed.getDate() + 1);
        returnObject.status = 'past';
        returnObject.text = Lang.langGet('valid until') + ' ' + localizeDate(to);

        if (toParsed > now) {
            returnObject.status = 'normal';
        }
    } else if (from !== undefined && to === undefined) {
        let fromParsed = exports.formatDate(from, 'MM/dd/YYYY');
        returnObject.status = 'normal';
        returnObject.text = Lang.langGet('valid from') + ' ' + localizeDate(from);

        if (fromParsed > now) {
            returnObject.status = 'future';
        }
    } else {
        let fromParsed = exports.formatDate(from, 'MM/dd/YYYY');
        let toParsed = exports.formatDate(to, 'MM/dd/YYYY');
        toParsed.setDate(toParsed.getDate() + 1);
        returnObject.status = 'normal';
        returnObject.text = localizeDate(from) + ' - ' + localizeDate(to);
        if (fromParsed > now) {
            returnObject.status = 'future';
        } else if (toParsed < now) {
            returnObject.status = 'past';
        }
    }

    if (time !== null) {
        returnObject.text += ', ';

        if (_.isString(time.From) && _.isString(time.To)) {
            const from = time.From;
            const to = time.To;

            if (!from && !to) {
                returnObject.text += Lang.langGet('full-time');
            }
            if (from && to) {
                returnObject.text += `${Lang.langGet('between')} ${time.From} ${Lang.langGet('and')} ${time.To}`;
            }
            if (from && !to) {
                returnObject.text += `${Lang.langGet('from')} ${time.From}`;
            }
            if (!from && to) {
                returnObject.text += `${Lang.langGet('to')} ${time.To}`;
            }

            return returnObject;
        }

        if (
            (time.From.HH === '00' && time.From.mm === '00' && time.To.HH === '00' && time.To.mm === '00') ||
            ((time.From.HH === null || time.From.mm === null) && (time.To.HH === null || time.To.mm === null))
        ) {
            returnObject.text += Lang.langGet('full-time');
        } else {
            if (time.From.HH === null || time.From.mm === null) {
                returnObject.text += Lang.langGet('to') +
                    ' ' +
                    time.To.HH +
                    ':' +
                    time.To.mm;
            } else if (time.To.HH === null || time.To.mm === null) {
                returnObject.text += Lang.langGet('from') +
                    ' ' +
                    time.From.HH +
                    ':' +
                    time.From.mm;
            } else {
                returnObject.text += Lang.langGet('between') +
                    ' ' +
                    time.From.HH +
                    ':' +
                    time.From.mm +
                    ' ' +
                    Lang.langGet('and') +
                    ' ' +
                    time.To.HH +
                    ':' +
                    time.To.mm;
            }
        }
    }

    return returnObject;
};

exports.formatDate = function (date, format) {
    if (!date) {
        return null;
    }

    var delimiter = /\W+/i;
    var formatedDate = null;
    var formatLowerCase = format.toLowerCase();
    var formatItems = formatLowerCase.split(delimiter);
    var dateItems = date.split(delimiter);
    var monthIndex = formatItems.indexOf('mm');
    var dayIndex = formatItems.indexOf('dd');
    var yearIndex = formatItems.indexOf('yyyy');
    var d = dateItems[dayIndex];

    if (d < 10) {
        d = '0' + d;
    }

    if (monthIndex > -1) {
        var month = parseInt(dateItems[monthIndex]);
        month -= 1;
        if (month < 10) {
            month = '0' + month;
        }
        formatedDate = new Date(dateItems[yearIndex], month, d);
    }

    return formatedDate;
};

function brightness(hexColor) {
    // Code from https://awik.io/determine-color-bright-dark-using-javascript/
    hexColor = +('0x' + hexColor.slice(1).replace(
        hexColor.length < 5 && /./g, '$&$&'));

    var r = hexColor >> 16;
    var g = hexColor >> 8 & 255;
    var b = hexColor & 255;

    return (r + r + b + g + g + g) / 6;
}

exports.isBright = function (hexColor) {
    if (!hexColor) {
        return 'unknown';
    }
    if (brightness(hexColor) > 127) {
        return 'light';
    } else {
        return 'dark';
    }
};

exports.brightnessDifference = function (hexColor1, hexColor2) {
    if (!hexColor1 || !hexColor2) {
        return 'unknown';
    }

    // Code from https://awik.io/determine-color-bright-dark-using-javascript/
    return brightness(hexColor1) - brightness(hexColor(2));
};

exports.delay = function (ms = 0) {
    return new Promise(resolve => setTimeout(resolve, ms));
};

exports.delayFrames = async function (numFrames = 1) {
    if (numFrames <= 0) return console.warn('delayFrames function requires a positive numFrames argument.');
    for (let i = numFrames; i > 0; i--) {
        await new Promise(requestAnimationFrame);
    }
};

exports.isArrayEmpty = function (array) {
    return Array.isArray(array) && !array.length;
};

/* https://dmitripavlutin.com/how-to-compare-objects-in-javascript/#3-shallow-equality */
exports.shallowEqual = function (object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }
    return true;
};

exports.isObject = function (value, isArray) {
    return (
        typeof value === 'object' &&
        value !== null &&
        (isArray === false || !Array.isArray(value))
    );
};

exports.arrayDiff = function (a, b) {
    return a.filter(element => !b.includes(element));
};

exports.formatToAspectRatioNum = function (formatString) {
    try {

        if (!formatString) return 1;

        const [num1, num2] = formatString.split(':').map(str => +str);

        if (num1 > 0) {
            if (num2 > 0) {
                return num1 / num2;
            } else {
                return num1;
            }
        } else {
            return 1;
        }

    } catch (e) {
        console.error(e);
        return 1;
    }

};

exports.registerDataTableFilterModes = function (FilterService) {

    // Compared to 'FilterService.filters.contains', the 'filter' value is expected
    // to be an array, not just a string value.
    FilterService.register('containsArray_OR', (field, filterArray, filterLocale) => {
        if (!filterArray || filterArray.length === 0) return true;
        return filterArray.some(filterEntry => FilterService.filters.contains(field, filterEntry, filterLocale));
    });

    // Compared to 'containsArray_OR', the entry must match ALL filter values.
    FilterService.register('containsArray_AND', (field, filterArray, filterLocale) => {
        if (!filterArray || filterArray.length === 0) return true;
        return filterArray.every(filterEntry => FilterService.filters.contains(field, filterEntry, filterLocale));
    });

    // Compared to 'FilterService.filters.contains', works on the 'name' property of each entry,
    // instead of the entry itself.
    FilterService.register('arrayContainsName', (field, filter, filterLocale) => {
        if (!filter) return true;
        return field.some(fieldEntry => FilterService.filters.contains(fieldEntry.name, filter, filterLocale));
    });

    // Compared to 'arrayContainsName', the 'filter' value is expected
    // to be an array, not just a string value.
    FilterService.register('arrayContainsNameArray_OR', (field, filterArray, filterLocale) => {
        if (!filterArray || filterArray.length === 0) return true;
        return filterArray.some(filterEntry => FilterService.filters['arrayContainsName'](field, filterEntry, filterLocale));
    });

    // Compared to 'arrayContainsNameArray_OR', the entry must match ALL filter values.
    FilterService.register('arrayContainsNameArray_AND', (field, filterArray, filterLocale) => {
        if (!filterArray || filterArray.length === 0) return true;
        return filterArray.every(filterEntry => FilterService.filters['arrayContainsName'](field, filterEntry, filterLocale));
    });

    FilterService.register('globalContainsName', (field, filter, filterLocale) => {
        if (!filter) return true; // If filter is empty, every field is a match
        if (Array.isArray(field)) {
            // field is an array
            if (field.length < 1) return false; // If field has no entries, it cannot be a match
            // recursively call this function with each field of the array, short circuit if a match is found
            return field.some(fieldEntry => FilterService.filters['globalContainsName'](fieldEntry, filter, filterLocale));
        } else {
            // field is not an array
            if (exports.isObject(field, false)) {
                // field is an object, check its 'name' property
                return FilterService.filters.contains(field.name, filter, filterLocale);
            } else {
                // field is not an object or array, perform normal 'contains' filtering
                return FilterService.filters.contains(field, filter, filterLocale);
            }
        }
    });

    // Compared to 'globalContainsName', the 'filter' value is expected
    // to be an array, not just a string value.
    FilterService.register('globalContainsNameArray', (field, filterArray, filterLocale) => {
        if (!filterArray || filterArray.length === 0) return true; // If filter is empty, every field is a match
        if (Array.isArray(field)) {
            // field is an array
            if (field.length < 1) return false; // If field has no entries, it cannot be a match
            // recursively call this function with each field of the array, short circuit if a match is found
            return field.some(fieldEntry => FilterService.filters['globalContainsName'](fieldEntry, filterArray, filterLocale));
        } else if (exports.isObject(field, false)) {
            // field is an object, check its 'name' property
            //return FilterService.filters.contains(field.name, filterArray, filterLocale)

            return filterArray.some(filterEntry => FilterService.filters.contains(field.name, filterEntry, filterLocale));
        } else {
            // field is not an object or array, perform normal 'contains' filtering
            //return FilterService.filters.contains(field, filterArray, filterLocale)

            return filterArray.some(filterEntry => FilterService.filters.contains(field, filterEntry, filterLocale));
        }
    });
};

/* https://bobbyhadz.com/blog/detect-when-element-is-added-or-removed-from-dom-using-javascript */
exports.startObservingDomMutations = function (domNode, listeners = {
    /*onAdded: undefined,*/
    /*onRemoved: undefined,*/
    /*onStyleChange: undefined*/
}) {
    const observer = new MutationObserver(mutations => {
        mutations.forEach((mutation) => {
            switch (mutation.type) {
                case 'childList':
                    if (listeners.onAdded) mutation.addedNodes.forEach(listeners.onAdded);
                    if (listeners.onRemoved) mutation.removedNodes.forEach(listeners.onRemoved);
                    break;

                case 'attributes':
                    if (listeners.onStyleChange && mutation.attributeName === 'style') listeners.onStyleChange(mutation.target);
                    break;
            }
        });
    });

    observer.observe(domNode, {
        childList: (!!listeners.onAdded || !!listeners.onRemoved),
        attributes: !!listeners.onStyleChange,
        characterData: true,
        subtree: true
    });

    return () => observer.disconnect();
};

exports.getBackgroundTypeFromMediaType = function (mediaType) {
    switch (mediaType) {
        case 'application/pdf':
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'text/plain':
            return 'solid';
        case 'image/png':
        case 'image/svg+xml':
            return 'checkered';
        default:
            return undefined;
    }
};

exports.caseInsensitiveSort = function (a, b) {
    return a.localeCompare(b, undefined, {sensitivity: 'base'});
};

exports.initGoogleMapsLibrary = function (apiKey) {
    /* https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import */
    (g => {
        var h,
            a,
            k,
            p = 'The Google Maps JavaScript API',
            c = 'google',
            l = 'importLibrary',
            q = '__ib__',
            m = document,
            b = window;
        b = b[c] || (b[c] = {});
        var d = b.maps || (b.maps = {}),
            r = new Set,
            e = new URLSearchParams,
            u = () => h || (h = new Promise(async (f, n) => {
                await (a = m.createElement('script'));
                e.set('libraries', [...r] + '');
                for (k in g) e.set(k.replace(/[A-Z]/g, t => '_' + t[0].toLowerCase()), g[k]);
                e.set('callback', c + '.maps.' + q);
                a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                d[q] = f;
                a.onerror = () => h = n(Error(p + ' could not load.'));
                a.nonce = m.querySelector('script[nonce]')?.nonce || '';
                m.head.append(a);
            }));
        d[l] ? console.warn(p + ' only loads once. Ignoring:', g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
    })({
        key: apiKey,
        v: 'weekly',
        language: Laravel.activeLanguage
        // Use the 'v' parameter to indicate the version to use (weekly, beta, alpha, etc.).
        // Add other bootstrap parameters as needed, using camel case.
    });
};

const camelizeKeys = (obj, skipWidgetKeys) => {
    if (Array.isArray(obj)) {
        return obj.map(v => camelizeKeys(v, skipWidgetKeys));
    }

    if (obj != null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => {
            const shouldSkip =
                skipWidgetKeys === true &&
                key.startsWith('WIDGET_');

            const transformedKey = shouldSkip
                ? key
                : _.camelCase(key);

            result[transformedKey] = camelizeKeys(obj[key], skipWidgetKeys);
            return result;
        }, {});
    }

    return obj;
};

const snakeKeys = (obj, skipWidgetKeys) => {
    if (Array.isArray(obj)) {
        return obj.map(v => snakeKeys(v, skipWidgetKeys));
    }

    if (obj != null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => {
            const shouldSkip =
                skipWidgetKeys === true &&
                key.startsWith('WIDGET_');

            const transformedKey = shouldSkip
                ? key
                : _.snakeCase(key);

            result[transformedKey] = snakeKeys(obj[key], skipWidgetKeys);
            return result;
        }, {});
    }

    return obj;
};

exports.transformAPIResponseIntoCapitalizedJSON = function (data, skipWidgetKeys = false) {
    return camelizeKeys(data, skipWidgetKeys);
};

exports.transformCapitalizedJSONIntoSnakeCase = function (data, skipWidgetKeys = false) {
    return snakeKeys({ ...data }, skipWidgetKeys);
};


const measureText = function (testContainer, fontSize, scale) {
    testContainer.style['font-size'] = `${fontSize * scale}px`;

    return {
        x: Math.max(testContainer.scrollWidth, 1),
        y: Math.max(testContainer.scrollHeight, 1)
    };
};

/**
 * @typedef {Object} FontAttributes
 * @property {?string} fontFamily
 * @property {?('underline' | 'none')} textDecoration
 * @property {?('italic' | 'normal')} fontStyle
 * @property {?('bold' | 'normal' | string | number) } fontWeight
 * @property { ?string | ?number } lineHeight
 */
/**
 * Calculate font size required to fit text into container of specified width and height
 * @param parentElement {HTMLElement} HTMLElement (native html tag) to attach a hidden testing container to, to inherit font attributes. Should be a reference to an element close to where the function is used, or the container itself that is holding the text (can also be its parent to avoid getting dozens of references for example, just not as high up the tree as the body tag).
 * @param width {number} The width of the target text container
 * @param height {number} The height of the target text container
 * @param text {string} The text being autosized
 * @param fontAttributes {?FontAttributes} Attributes (styles) set to the testing container to affect text style. The rest is inherited from {@link parentElement}
 * @param numIterations {?number} Number of size calculations to perform. Defaults to 8 (POV Client has the same setting)
 * @param autoscale {number} When set to -1 (default if omitted), will autoscale. Required for other uses
 * @returns {number} Calculated font size in px
 */
exports.calculateFontAutosize = function (parentElement,
                                          width,
                                          height,
                                          text,
                                          fontAttributes = undefined,
                                          numIterations = 8,
                                          autoscale = -1
) {
    const fontSize = 32;

    const styles = {
        fontSize: `${fontSize}px`,
        wordWrap: 'normal',
        whiteSpace: 'pre-wrap',
        userSelect: 'none'
    };

    if (fontAttributes?.fontFamily)
        styles.fontFamily = `"${fontAttributes.fontFamily}"`;

    if (fontAttributes?.textDecoration)
        styles.fontFamily = fontAttributes.textDecoration;

    if (fontAttributes?.fontStyle)
        styles.fontFamily = fontAttributes.fontStyle;

    if (fontAttributes?.fontWeight)
        styles.fontFamily = fontAttributes.fontWeight;

    const parentContainer = document.createElement('div');
    parentContainer.style.position = 'absolute';
    parentContainer.style.width = `${width}px`;
    parentContainer.style.height = `${height}px`;
    parentContainer.style.overflow = 'auto';
    parentContainer.style['line-height'] = fontAttributes?.lineHeight ? `${fontAttributes.lineHeight}` : '1.15';
    parentContainer.style['font-size'] = 0;

    const testContainer = document.createElement('div');
    testContainer.innerHTML = text;
    testContainer.style.visibility = 'hidden';
    testContainer.style.width = '100%';
    Object.entries(styles).forEach(([key, value]) => testContainer.style[key] = value);

    parentContainer.appendChild(testContainer);
    parentElement.appendChild(parentContainer);

    let scale = 1;
    let measures = measureText(testContainer, fontSize, scale);

    if (autoscale < 0) {
        scale *= Math.sqrt(height / measures.y);
        measures = measureText(testContainer, fontSize, scale);
    }

    width = Math.floor(width);
    height = Math.floor(height);

    if (measures.y > height || measures.x > width || autoscale < 0) {
        // Scale down
        let upperBound = scale;
        let lowerBound = scale;

        // --- Binary Search Algorithm. ---
        // Find UpperBound
        for (let i = 0; i <= numIterations; i++) {
            measures = measureText(testContainer, fontSize, upperBound);
            if (measures.x > width || measures.y > height) {
                break;
            }
            upperBound *= Math.max(2, width / measures.x, height / measures.y);
        }
        // Find LowerBound
        for (let i = 0; i <= numIterations; i++) {
            measures = measureText(testContainer, fontSize, lowerBound);
            if (measures.x <= width && measures.y <= height) {
                break;
            }
            lowerBound /= Math.max(2, measures.x / width, measures.y / height);
        }

        for (let i = 0; i <= numIterations; i++) {
            scale = (lowerBound + upperBound) / 2;
            measures = measureText(testContainer, fontSize, scale);

            let heightRatio = measures.y / height;
            let widthRatio = measures.x / width;

            if (Math.abs(widthRatio - 1) < 0.001 && Math.abs(heightRatio - 1) < 0.001) {
                break;
            } else if (widthRatio < 1 && Math.abs(heightRatio - 1) < 0.001) {
                break;
            }

            if (widthRatio - 1 > 0.001 || heightRatio - 1 > 0.001) {
                upperBound = scale;
            } else {
                lowerBound = scale;
            }
        }
        // --- Same algorithm as in POV Client code. ---
        /*
        let bestHeightRatio = -1;
        let bestScale = scale;

        for (let i = 0; i <= 8; i++) {
            if(measures.x > this.width) {
                scale *= Math.sqrt(this.width / measures.x);
            } else {
                scale *= Math.sqrt(this.height / measures.y);
            }

            measures = this.measureText(testContainer, scale);

            let heightRatio = measures.y / this.height;

            if (bestHeightRatio > 0) {
                if (bestHeightRatio === heightRatio && measures.x <= this.width) {
                    break;
                }
            }

            let compareWidth = 0.999*measures.x; //0.999: approximation margin (such that slightly too large is okay)
            if (heightRatio < 1 && compareWidth < this.width && heightRatio > bestHeightRatio) {
                bestHeightRatio = heightRatio;
                bestScale = scale;
            }

            if (compareWidth <= this.width && measures.y < this.height && heightRatio > 0.95) {
                bestScale = scale;
                break;
            }
        }
        scale = bestScale;*/
        scale *= 0.995;
    }

    parentElement.removeChild(parentContainer);

    return fontSize * scale;
};
